import { createContext, ReactNode, useContext } from "react";

/** Contenu injecté à droite de la pagination (ex. bascule liste/grille). */
export const PaginationToolbarContext = createContext<ReactNode>(null);

export function usePaginationToolbarExtra(): ReactNode {
  return useContext(PaginationToolbarContext);
}
